import en from './translate/en.json'
import ru from './translate/ru.json'
import fr from './translate/fr.json'

import { initReactI18next } from 'react-i18next'
import i18next from 'i18next'

const resources: { [key: string]: { translation: any; }}  = {
    en: {
        translation: en,
    },
    ru: {
        translation: ru,
    },
    fr: {
        translation: fr,
    }
}

i18next
.use(initReactI18next)
.init({
    resources,
    //@ts-ignore
    lng: JSON.parse(localStorage.getItem('language')),
    fallbackLng: 'en'
})

export default i18next